import { render } from "./ProductCategoriesStage.vue?vue&type=template&id=331a5278&scoped=true"
import script from "./ProductCategoriesStage.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesStage.vue?vue&type=script&lang=js"

import "./ProductCategoriesStage.vue?vue&type=style&index=0&id=331a5278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331a5278"]])

export default __exports__